import React, { useState } from 'react';
import Header from './Header';
import HeroSection from './HeroSection';
import AboutSection from './AboutSection';
import ServicesSection from './ServicesSection';
import ConsultantsSection from './ConsultantsSection';
import PortfolioSection from './PortfolioSection';
import ContactSection from './ContactSection';
import Footer from './Footer';

const LandingPage = () => {
  const [activeSection, setActiveSection] = useState('home');

  return (
    <div className="landing-page">
      <Header activeSection={activeSection} setActiveSection={setActiveSection} />
      <main className="pt-32">
        <HeroSection id="home" />
        <AboutSection id="about" />
        <ServicesSection id="services" />
        <ConsultantsSection id="team" />
        <PortfolioSection id="portfolio" />
        <ContactSection id="contact" />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;